import React, { useState, useEffect } from 'react'
import Breadcumb from '../../components/Breadcumb/Breadcumb'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import UploadImageModal from '../../components/ImageEditor/UploadImageModal';
import CreateImageModal from '../../components/ImageEditor/CreateImageModal';
import ReactPaginate from 'react-paginate';
import { Alerts, Images } from "../../helpers";
const BreadcrumbData = [
    {
        id: 1,
        page_title: "Dashboard",
        page_path: "/",
        icon: "tachometer",
    },
    {
        id: 2,
        page_title: "Images Gallery",
        page_path: "/",
        icon: "tachometer",
    }
]

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
    },
    formHeading: {
        fontSize: '20px !important',
        marginTop: 0,
        marginBottom: 10,
        textTransform: "uppercase",
        fontWeight: 600
    },
    pageTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#f7f7f7',
        marginBottom: '20px',
        padding: '10px 20px',
    },
    imageContainer: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        background: '#fcfcfc',
        // margin: 10
    },
    image: {
        width: '100%'
    },
    imagesActions: {
        position:'absolute',
        bottom:'9px',
        textAlign:'center',
        width: '100%'
    },
    button1:{
        width:'30px !important',
        marginRight:5
    }
}));

const ImageGallery = () => {
    const [imageId, setImageId] = useState(null);
    const classes = useStyles();
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(12);
    const [page, setPage] = useState('');
    const [imageCount, setImageCount] = useState(0);

    const [open, setOpen] = useState(false);
    const handleClickOpen = (id) => {
        setImageId(id)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };



    const getDate = async (limit_per_page, page_no) => {
        setLoading(true)
        const resp = await Images.getImages(limit_per_page, page_no);
        if (resp) {
            setLoading(false)

            if (resp.status) {
                setData(resp.images)
                setImageCount(Math.ceil(resp.imageCounts / limit));
            } else {
                console.log(resp);
            }

        }
    }
    useEffect(() => {
        getDate(limit, page);
    }, [])

    const handleUploadImage = async (acceptedFiles) => {
        setLoading(true)
        let formData = new FormData()
        for (let i = 0; i < acceptedFiles.length; i++) {
            formData.append("images", acceptedFiles[i]);
        }
        let resp = await Images.uploadImage(formData);
        if (resp) {
            Alerts.alertMessage(resp.message, "", "success");
            getDate();
            setLoading(false)
            window.location.reload();
        }

    }

    const removeImage = async (id) => {
        let resp = await Images.removeImage(id);
        if (resp) {
            Alerts.alertMessage(resp.message, "", "success");
            setData(data.filter(el=>el.id !== id));
            // window.location.reload();
        }
    }
    const editImage = async(data)=>{
        let resp = await Images.createImage(imageId, data);
        if (resp) {
            const id = resp.created_image.id;
            if(resp.status){
                window.location=`/app/images/create/${id}`
            }
        }
    }
    const handlePageClick = (e) =>{
     // console.log(e.selected);
      getDate(limit, e.selected)
    }
    return (
        <>
            <Breadcumb items={BreadcrumbData} />
            <div className="page-wrapper pd30">
                <div className={classes.root}>

                    <Grid container >

                        <Grid item xs={12}>
                            <Paper className={classes.paper}>
                                <div className={classes.pageTitle}>
                                    <h3 className={classes.formHeading}> Images Gallery</h3>
                                    <UploadImageModal onUpload={handleUploadImage} />
                                    

                                </div>
                                {
                                   isLoading ?<div className='dataLoading'>
                                        <img src={process.env.PUBLIC_URL + '/loader.gif'} alt="" />
                                    </div> : <Grid container spacing={2}>
                                        {
                                            data && data.length !== 0 ?
                                                data.map((item, i) => {
                                                    return <Grid key={i} item xs={3} className={classes.imageContainer}>
                                                        <img src={item.image} alt={item.image} className={classes.image} />
                                                        <div className={classes.imagesActions}>
                                                            <Button className={classes.button1} variant="contained" color="secondary" onClick={() => removeImage(item.id)}>
                                                                <DeleteIcon />
                                                            </Button>
                                                            <Button type="button" variant="contained" color="primary" onClick={()=>handleClickOpen(item.id)}>Create Image</Button>
                                                        </div>
                                                    </Grid>
                                                })
                                                : <div className='data-notfound'> Data not found ! </div>
                                        }

                                    </Grid>
                                }

                       <div className='text-center'>
                        <ReactPaginate
                            className="gallery-pagination"
                            breakLabel="..."
                            nextLabel="next >"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={12}
                            pageCount={imageCount}
                            previousLabel="< previous"
                            renderOnZeroPageCount={null}
                        />
                    </div>
                            </Paper>
                        </Grid>
                    </Grid>
                    {
                        open &&  <CreateImageModal open={open} handleClose={handleClose} editImage={editImage}/>
                    }
                   
                </div>
            </div>
        </>
    )
}

export default ImageGallery